import React, { useState } from "react";
import { FaYoutube } from "react-icons/fa";
import Disclaimer from "../components/molecules/disclaimer/disclaimer";
import Paginator from "../components/molecules/paginator/Paginator";
import PreviewCard, {
  PreviewCardProps,
} from "../components/molecules/PreviewCard/PreviewCard";
import Suscribe from "../components/molecules/suscribe/suscribe";
import AsideBar from "../components/organisms/aside/AsideBar";
import GridLayout from "../components/organisms/grid-layout/GridLayout";
import Layout from "../components/organisms/layout/layout";
import VideosCarousel from "../components/organisms/videos-carousel/videos-carousel";
import VideosHeader from "../components/organisms/videos-header/videos-header";
import { adapterSuscribe } from "../components/templates/library-components/adapters";
import SEO from "../shared/seo";
import { dateToRelativeFormat } from "../utils/dateToRelativeFormat";
import "./../styles/index.scss";

const VideosTemplate = (props: any) => {
  const pageData = props.pageContext.pageContent;
  const { slug, numPages, currentPage, elements } = props.pageContext;
  const videos = elements.map((node) => {
    return {
      imagen: node.referenciaInterna.referenciaCabecera.imagenHeader.file.url,
      video: node.referenciaInterna.referenciaCabecera.redireccionBoton,
      titulo: node.referenciaInterna.referenciaCabecera.tituloPrincipal,
      span: node.referenciaInterna.referenciaCabecera.tituloSpan,
      migaDePan: node.referenciaInterna.referenciaCabecera.migaDePan,
      slug: node.slug,
      fecha: node.createdAt,
    };
  });
  const [actualVideo, setActualVideo] = useState(videos[0]);

  return (
    <Layout hideHeaderDesktop={false} hideHeaderMobile={false} isNotRoot={true}>
      <SEO
        title={pageData.metaTitulo || pageData.nombreCategoria}
        slug={slug}
        description={
          pageData.metaDescripcion &&
          pageData.metaDescripcion.json.content[0].content[0].value
        }
        image={
          pageData.referenciaCabecera.imagenHeader &&
          pageData.referenciaCabecera.imagenHeader.file.url
        }
        lang="es"
      />
      <VideosHeader
        actualVideo={actualVideo}
        videos={videos}
        setActualVideo={setActualVideo}
      />
      <VideosCarousel
        videos={videos}
        actualVideo={actualVideo}
        setActualVideo={setActualVideo}
      />
      <GridLayout columns="2fr 1fr" gap="2rem" padding="1rem 0">
        <div>
          {videos.map((element, i) => {
            let process: PreviewCardProps = {
              description: element.span,
              imageUrl: element.imagen,
              leftSub: "Video",
              link: element.video?.replace("embed/", "watch?v="),
              external: true,
              rightSub: dateToRelativeFormat(element.fecha),
              title: element.titulo,
              icon: <FaYoutube />,
            };
            return <PreviewCard {...process} key={i} />;
          })}
        </div>
        <AsideBar />
      </GridLayout>
      <Paginator slug={slug} quantity={numPages} currentPage={currentPage} />
      <Suscribe {...adapterSuscribe()} />
      <Disclaimer />
    </Layout>
  );
};

export default VideosTemplate;
